export default "__VITE_ASSET__Cp_Htx80__"